// extracted by mini-css-extract-plugin
module.exports = {"cursorPointer":"neighbourhood_cursorPointer__2cFWJ","tablePagination":"neighbourhood_tablePagination__1_tfn"};